import Modal, { Mode } from "@components/common/modal";
import { ComponentData } from "@constants/component-data";
import { memo } from "react";

export type alertModalType =
  | "common"
  | "delete"
  | "deleteC"
  | "restore"
  | "bookmark"
  | "bookmarkC"
  | "delete_success"
  | "unable"
  | "update"
  | "createDateCheck"
  | "workFieldCheck"
  | "noDelete"
  | "counselDesignCheck"
  | "nullDesignTemplateId"
  | "counselFacilityType";

type Props = {
  visible: boolean;
  modalMode: Mode;
  alertCallback?(value: boolean): void;
  type: alertModalType;
};

const Index = ({ visible, modalMode, alertCallback, type }: Props) => {
  return (
    <Modal open={visible} mode={modalMode} onClose={e => alertCallback(e)}>
      <div className="text-center">
        <div className="my-5">
          <i className={`dx-icon-${ComponentData.AlertData[type]?.icon} dx-custom-alert`}></i>
        </div>
        <h2 className="text-2xl">{ComponentData.AlertData[type]?.title}</h2>
        <span>{ComponentData.AlertData[type]?.text}</span>
      </div>
    </Modal>
  );
};

export default memo(Index);
